/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 929
// module chunks = 2